var _style, _path, _path2, _path3, _circle, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D80027;}\n\t.st1{fill:#0052B4;}\n\t.st2{fill:#F0F0F0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512,256c0,141.4-114.6,256-256,256S0,397.4,0,256C87.9,168.1,162.5,93.5,256,0C397.4,0,512,114.6,512,256z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,256c0-141.4,0-158.1,0-256C114.6,0,0,114.6,0,256H256z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M222.6,149.8l-31.3,14.7l16.6,30.3l-33.9-6.5l-4.3,34.3l-23.6-25.2l-23.6,25.2l-4.3-34.3l-33.9,6.5l16.6-30.3 l-31.3-14.7l31.3-14.7l-16.6-30.3l33.9,6.5l4.3-34.3l23.6,25.2L169.7,77l4.3,34.3l33.9-6.5l-16.6,30.3L222.6,149.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 146.1,
    cy: 149.8,
    r: 47.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M146.1,175.2c-14,0-25.4-11.4-25.4-25.4s11.4-25.4,25.4-25.4c14,0,25.4,11.4,25.4,25.4 C171.5,163.8,160.1,175.2,146.1,175.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.68c31987777cbdded304ec71e1000b19.svg";
export { ForwardRef as ReactComponent };